<template>
    <div class="staffBox">
        <avue-crud :data="data"  ref="crud" :option="option" @selection-change="selectionChange">
            <template slot-scope="scope" slot="menuLeft">
                <el-button class="custom" type="primary" @click="authorizeBtn">合同模板授权给企业员工</el-button>
            </template>
            <template slot-scope="scope" slot="mobile">
                <p>{{scope.row.mobile.slice(-4)}}</p>
            </template>
        </avue-crud>
    </div>
</template>

<script>
import { empowerEmployees, getEnterpriseStaffList } from '@/api/template_kh';
import bus from '@/components/common/bus';

export default {
    name: 'staffList',
    data(){
        return{
            ids:'',
            data:[],
            option: {
                stripe: true,
                // index:true,
                searchMenuSpan: 3,
                indexLabel: '序号',  //添加序号
                selection: true, //批量选择
                addBtn: false,  //新增按钮
                align: 'center',  //文本居中
                menuAlign: 'center', //操作栏居中
                columnBtn: false,  //列动态显隐按钮
                refreshBtn: false,  //刷新按钮
                editBtn: false,  //编辑按钮
                delBtn: false,  //删除按钮
                menuWidth: 150,  //操作栏宽度设置
                menu:false,
                menuType: 'menu',
                menuBtnTitle: '操作',
                column: [
                    {
                        label: '员工姓名',
                        prop: 'name',
                    },
                    {
                        label: '员工手机号',
                        prop: 'mobile',
                    },
                ]
            }
        }
    },
    methods:{
        //批量操作
        selectionChange(list) {
            this.ids = [];
            list.forEach(res => {
                this.ids.push(res.id);
            });
        },
        getList(){
            getEnterpriseStaffList().then(res=>{
                if (res.code==200){
                    this.data=res.data.list
                }else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 授权
        authorizeBtn(){
            if (this.ids == '' || this.ids == undefined){
                this.$message.error('请选择要授权的员工');
                return false
            }else {
                this.$confirm('请确认是否要授权给该员工 ', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    empowerEmployees({tpl_id:this.$route.query.tpl_id,yg_ids:this.ids}).then(res=>{
                        if (res.code==200){
                            this.$message.success(res.msg);
                            bus.$emit('close_current_tags')
                            this.$router.push({
                                path:'/templateList'
                            })
                        }else {
                            this.$message.error(res.msg)
                        }
                    })
                }).catch(() => {

                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped>
    .staffBox{
        background-color: #ffffff;
        padding: 20px;
        border-radius: 5px;
    }
</style>